<template>
    <transition name="fade" mode="out-in">
        <div v-if="visible" class="mega-modal" @click.self="hide">
            <div class="card h-100">
                <h5 class="card-header">
                    {{ printable.name }}
                    <button type="button" class="close" aria-label="Close" @click="hide">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </h5>
            
                <div v-if="loading" class="loading">
                    <fa-layer class="fa-lg fa-6x">
                        <fa :icon="['fas','cloud']" />
                        <fa :icon="['fal','arrow-down']" class="loading-icon" transform="shrink-9 right-2 down-1" style="color: white;" />
                    </fa-layer>
                </div>

                <template v-else>
                    <div class="card-dashboard assemble p-0">

                        <div class="templates py-3 pl-3">
                            <div :class="['templates-page',pages[activePage-1] && !pages[activePage-1].template ? 'active' : '']" 
                                :style="templatePage()" @click="clearTemplate()">
                            </div>
                            
                            <div v-for="(template,index) in templates" :key="index" 
                                class="templates-page" 
                                :class="{active : pages[activePage-1] && pages[activePage-1].template == template.id}"
                                :style="templatePage(template)"
                                @click="setActiveTemplate(template)">
                            </div>
                        </div>

                        <div class="spread p-3" ref="spread">
                            <div v-for="side in sides" :key="side" 
                                :ref="'side' + side" 
                                :class="[
                                    'side-' + side, 
                                    activeSpread[side] == activePage ? 'active' : '',
                                    isDeadleft(side),
                                    isBastard(side)
                                ]" 
                                :style="[sizeStyle,backgroundStylePage(side)]"
                                @click="clearArea();setActivePage(activeSpread[side])" :data-page="activeSpread[side]">

    
                                <template v-if="pages && activeSpread && pages[activeSpread[side]-1]">
                                    <div v-for="(area,index) in pages[activeSpread[side]-1].templateareas" 
                                        :key="index" 
                                        :class="['template-area', activeSpread[side] + '.' + index == activeArea ? 'active' : '']"
                                        :style="[templateAreaStyle(area),backgroundStyleArea(activeSpread[side] + '.' + index)]"
                                        @click.stop="setActiveArea(activeSpread[side],index)">
                                    </div>
                                </template>
                                
                                <div class="page-tools d-flex">
                                    <button class="btn tool tool-danger" v-tooltip="'Rensa sida'" @click.stop="clearPage(activeSpread[side]-1)">
                                        <fa :icon="['far','trash']" class="text-white" fixed-width />
                                    </button>

                                    <button 
                                        class="mr-auto ml-1 btn tool" 
                                        v-tooltip="hasPagination(activeSpread[side]-1) ? 'Inaktivera paginering' : 'Aktivera paginering'" 
                                        @click.stop="togglePagination(activeSpread[side]-1)"
                                        :class="hasPagination(activeSpread[side]-1) ? 'btn-secondary' : 'btn-danger'"
                                    >
                                        
                                        <fa v-if="hasPagination(activeSpread[side]-1)" :icon="['far','hashtag']" class="text-white" fixed-width />

                                        <fa-layer v-if="!hasPagination(activeSpread[side]-1)" fixed-width>
                                            <fa :icon="['far','hashtag']" class="text-gray" transform="shrink-4" />
                                            <fa :icon="['fal','ban']" class="text-white" transform="grow-5" />
                                        </fa-layer>
                                    </button>

                                    <button class="mr-1 btn tool tool-success"  v-tooltip="'Ny sida till vänster'" @click.stop="addBlankPage(activeSpread[side]-1)">
                                            <fa :icon="['far','arrow-left']" class="text-white" transform="shrink-6" />
                                            <fa :icon="['fas','plus']" class="text-white"/>
                                    </button>

                                    <button class="mr-1 btn tool tool-success" v-tooltip="'Ny sida till höger'" @click.stop="addBlankPage(activeSpread[side])">
                                            <fa :icon="['fas','plus']" class="text-white"/>
                                            <fa :icon="['far','arrow-right']" class="text-white" transform="shrink-6" />
                                    </button>
                                    <button class="tool btn tool-warning"  v-tooltip="'Ta bort sida'" @click.stop="removePage(activeSpread[side]-1)">
                                        <fa :icon="['far','minus']" class="text-white" fixed-width />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="disposition page-list-height py-3" :class="{'displace' : start_with_rightside}" >
                            <div v-for="(page,index) in pages" :key="index" 
                                class="disposition-page" 
                                :class="{active : activePage == index+1}"
                                :style="dispositionPage(page)"
                                :data-page="index + 1"
                                @click="setActivePage(index+1)">
                                <div class="disposition-tools">
                                    <a href="#" @click.stop="removePage(index)">
                                        <fa :icon="['fas','minus-circle']" fixed-width />
                                    </a>
                                </div>
                            </div>

                            <div class="disposition-page spread add-new" @click="addPage(2)" :style="dispositionPage('spread')" data-page="">
                                <fa :icon="['fal','plus']" class="text-success" />
                            </div>
                            <div class="disposition-page add-new" @click="addPage(1)" :style="dispositionPage(null)" data-page="">
                                <fa :icon="['fal','plus']" class="text-success" />
                            </div>
                        </div>

                        <card no-title flex-scroll class="components my-3 mr-3">
                             <header slot="header">
                                <h4>Komponenter</h4>
                            </header>
                            
                            <ul v-if="printable && printable.components" class="list-unstyled  component-list">
                                <li v-for="component in printable.components" :key="component.id">
                                    <span v-if="component.attachment.attachment_pages_count > 1" @click="togglePages(component.id)">
                                            <fa :icon="['fal', expanded.includes(component.id) ? 'minus-circle' : 'plus-circle']" /> 
                                        </span>
                                        <fa v-else :icon="['fas','circle']" transform="shrink-10" :class="isActive(component.id,1)" />
                                    <a v-if="component.attachment.attachment_pages_count == 1" href="#" @click="setPageComponent(component)">
                                        {{ component.attachment.filename }}
                                    </a>
                                    <a v-else href="#" @click="insertFullComponent(component)">
                                        {{ component.attachment.filename }}
                                    </a>

                                    <ul v-if="component.attachment.attachment_pages_count > 1 && expanded.includes(component.id)" 
                                        class="list-unstyled ml-3">
                                        <li v-for="page in component.attachment.attachment_pages"
                                            :key="component.id + '.' + page.page_number">
                                            <a href="#" @click="setPageComponent(component,page)">
                                                <fa :icon="['fas','circle']" transform="shrink-10" :class="isActive(component.id, page.page_number)" /> 
                                                Sida {{ page.page_number }}
                                            </a>
                                        </li>
                                    </ul>
                                    
                                </li>
                            </ul>
                        
                        </card>
                    </div>
                    
                    <div class="card-footer d-flex">
                        <a :href="'/api/pdf/' + printable.id + '?preview=true'" target="_blank" class="btn btn-primary mr-auto">
                            <fa :icon="['fal','external-link']" fixed-width />
                            Förhandsgranska
                        </a>


                        <a class="btn btn-sm text-success" @click="savePages">
                            Spara
                        </a>
                    </div>
                </template>
            </div>
        </div> 
    </transition>
</template>

<script>
import axios from 'axios';
import store from '~/store'
import Card from '~/components/Card';
import swal from "sweetalert2";

export default {
    name: "AssembleModal",
    middleware: ['auth'],
    components: {
        Card
    },
    data(){
        let page = {
            component : null,
            componentpage : null,
            background_image :''
        };

        return {
            expanded : [],
            loading: false,
            version: Math.random(),
            visible: false,
            sides: ['left','right'],
            pageleft : page,
            pageright : page,
            activePage : 1,
            activeArea: null,
            activeTemplate : null,
            activeTemplateAreas: [],
            activeSpread: {left:0,right:0},
            printable_id : null,
            page_height : 0,
            spreadMargin : 20,
            start_with_rightside: 1,
            ratio : 0,
            scale : 0,
            pages : [],
            templates : []
        }
    },
    metaInfo () {
        return { title: this.$t('assemble') }
    },
    created(){
        if(this.$route.params.id){
            this.printable_id = this.$route.params.id;
            
            window.addEventListener('resize', this.setPageSize);
        }
    }, 
    computed: {
        sizeStyle(){
            return {
                height : this.page_height + 'px',
                width: this.page_width + 'px'
            }
        },
    },
    methods : {
        hasPagination(page){
            if(this.pages[page]){
                return !this.pages[page].disable_pagination;
            }
        },
        togglePagination(page){
            if(this.pages[page]){
                this.pages[page].disable_pagination = !this.pages[page].disable_pagination;
                this.setActivePage(this.activePage);
            }
        },
        blankPage(){
            return {
                attachment : null,
                attachment_id : null,
                attachment_page : null,
                attachment_page_id : null,
                path : null,
                template_id : null
            }
        },
        clearPage(index){
            this.pages[index] = this.blankPage();
            this.setActivePage(this.activePage);
        },
        addBlankPage(index){
            this.pages.splice(index,0,this.blankPage());
        },
        removePage(index){
            this.pages.splice(index,1);
        }, 
        dispositionPage(page){
            let url = page && page.attachment_page ? page.attachment.prefix + page.path : '';
            let width = 33;

            return {
                'height' : this.ratio * width + 'px',
                'width' : (page == "spread" ? 70 : width) + 'px',
                'background-image' : 'url("' + url + '")',
                'background-size' : 'cover'
            }
        },
        templatePage(page){
            let width = 70;
            let background_image = page && page.thumbnail ? page.thumbnail : '';

            return {
                'width' : width + 'px',
                'height' : this.ratio * width + 'px',
                'background-image' : 'url("' + background_image  + '")',
                'background-size' : 'cover'
            }
        },
        templateAreaStyle(area){
            let style = {
                'width': area.width * this.scale_factor + 'px',
                'height': area.height * this.scale_factor + 'px',
                'top': (area.top * this.scale_factor)-1 + 'px',
                'left': (area.left * this.scale_factor)-1 + 'px' 
            }
            console.log(area,style,this.scale_factor);

            return style;
        },
        addPage(number){
            if(!number) number = 1;
            
            for(let i = 0; i<number; i++){
                this.pages.push({});
            }
        },
        togglePages(id){
            if(this.expanded.includes(id)){
                this.expanded.splice(this.expanded.indexOf(id))
            } else {
                this.expanded.push(id);
            }

        },
        hide () {
            this.visible = false;
            this.$emit('clear');
        },
        show (origin) {
            if(this.$route.name){
                this.visible = true;
            }
        },
        isActive(id,pageNo){
            
            let found = this.pages.find(el => (el.component && el.page) ? el.component.id == id && el.page.page_number == pageNo : false)

            return found ? 'text-success' : 'text-gray';
        },
        isDeadleft(side){
            return this.start_with_rightside && side == 'left' && this.activeSpread.left == 0 ? 'hidden' : '';
        },
        isBastard(side){
            return side == 'right' && !this.pages[this.activeSpread.right - 1] ? 'hidden' : '';
        },
        clearArea(){
            this.activeArea = null;
        },
        clearTemplate(){
            let page = this.pages[this.activePage - 1];

            page.templateareas = null;
            page.template = null;

            this.setActivePage(this.activePage);
        },
        setActivePage(page){
            let side = 'left';

            if(this.start_with_rightside){
                side = page % 2 == 1 ? 'right' : 'left';
            } else {
                side = page % 2 == 0 ? 'right' : 'left';
            }

            this.activePage = page;
            this.activeSpread = side == 'left' ? {left:page,right:page+1} : {left:page-1,right:page}
            
            this.pageleft = this.pages[this.activeSpread.left - 1];
            this.pageright = this.pages[this.activeSpread.right - 1];

            console.log(this.pageleft, this.pageright);
        },
        setActiveTemplate(template){
            let page = this.pages[this.activePage - 1];
            
            page.template = template.id;
            page.templateareas = JSON.parse(JSON.stringify(template.templateareas));
            page.path = null;

            for(let prop in page) {
                if(prop.substr(0,10) == 'attachment') page[prop] = null;
            }
            
            this.setActivePage(this.activePage);
        },
        setActiveArea(page,area){
            this.setActivePage(page);
            this.activeArea = page + '.' + area; 
        },
        getTemplateArea(tpl_id,tplarea_id){
            let template = this.printable.printable_type.templates.find(tpl => tpl.id == tpl_id);

            console.log("TA", tpl_id, tplarea_id, template);

            if(template && template.templateareas){
                let template_area = template.templateareas.find(tplarea => tplarea.id == tplarea_id);
                return template_area;
            } else {
                return null
            }
        },
        makePage(page){
            let newpage = this.blankPage();
            if(page && page.attachment_page){
                newpage.path = page.attachment_page.path;
                newpage.attachment = page.attachment;
                newpage.attachment_id = page.attachment_id;
                newpage.attachment_page_id = page.attachment_page_id;
                newpage.attachment_page = page.attachment_page;
                newpage.printable_page_number = page.printable_page_number;
                newpage.template_id = page.template_id;
                newpage.template_area_id = page.template_area_id;
                newpage.disable_pagination = page.disable_pagination;
            }

            return newpage;
        },
        parsePages(loaded_pages){
            let pages = [];

            Object.values(loaded_pages).forEach(page => {
                if(page.length == 1){ //Single page
                    pages.push(this.makePage(page[0]))
                } else { // Template areas
                    let temp_page = this.makePage();
                    temp_page.templateareas = [];

                    page.forEach(ta => {
                        let template_area = this.getTemplateArea(ta.template_id,ta.template_area_id);
                        temp_page.templateareas.push({...template_area,...this.makePage(ta)});
                    });

                    pages.push(temp_page);
                }
            });
            console.log("PAGES", pages);
            this.pages = pages;
            if(pages.length == 0){
                this.addPage(1);
            }
            this.setActivePage(1);
        },
        parsePrintable(){
            if(this.printable.printable_type){
                let printable_type = this.printable.printable_type;
                //Inactivated due to always starting with right side. Uncomment for dynamic behavior
                //this.start_with_rightside = this.printable.printable_type.start_with_rightside;
                this.templates = this.printable.printable_type.templates;
                this.mergeTemplateAreas();
                
                this.$nextTick(this.setPageSize);
                this.parsePages(this.printable.printable_pages_grouped);
            }
        },
        mergeTemplateAreas(){
            /*let pages = this.printable.printable_pages_grouped;

            Object.values(loaded_pages)
            console.log(pages);
            /*if(pages){
                pages.map(page => {
                    page.map(component => {
                        console.log(component);
                    })
                })
            }*/
        },
        backgroundStylePage(side){
            let pageno = this.activeSpread[side]-1;
            let page = this.pages[pageno];

            if(page && page.path){
                let style = {
                    'background-image' : 'url(' + page.attachment.prefix + page.path + '?v=' + Math.random() + ')'
                };

                return style;
            }
        },
        backgroundStyleArea(current){
            if(current){
                let areaId = current.split('.');
                let area = this.pages[areaId[0] - 1].templateareas[areaId[1]];

                if(area && area.path){
                    let style = {
                        'background-image' : 'url(' + area.attachment.prefix + area.path + '?v=' + Math.random() + ')'
                    };

                    return style;
                }
            }
        },
        setPageComponent(component,attachmentpage){
            if(attachmentpage){
                attachmentpage = component.attachment.attachment_pages.find(el => el.id == attachmentpage.id);
            } else {
                attachmentpage = component.attachment.attachment_pages[0];
            }
            
            let page = {
                attachment : component.attachment,
                attachment_id : component.attachment.id,
                attachment_page : attachmentpage.page_number,
                attachment_page_id : attachmentpage.id,
                path : attachmentpage.path
            }
            
            if(this.activeArea){
                let areaId = this.activeArea.split('.');
                let area = this.pages[areaId[0] - 1].templateareas[areaId[1]]
                
                this.pages[areaId[0] - 1].templateareas[areaId[1]] = {
                    ...area,
                    ...page
                }
            } else {
                let current = this.pages[this.activePage - 1];

                if(!current.templateareas){
                    this.pages[this.activePage - 1] = {
                        ...page
                    }
                }
            }
            
            this.setActivePage(this.activePage);
        },
        insertFullComponent(component){
            swal({
                title: "Infoga hela komponenten?",
                text: "",
                type: "question",
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: this.$t("ok"),
                confirmButtonClass: "bg-info",
                cancelButtonText: this.$t("cancel")
            }).then(result => {
                if (result.value) {
                    let index_start = this.activePage - 1;
                    let insert_pages = component.attachment.attachment_pages.reverse(); 

                    insert_pages.forEach(attachmentpage => {
                        let page = {
                            attachment : component.attachment,
                            attachment_id : component.attachment.id,
                            attachment_page : attachmentpage.page_number,
                            attachment_page_id : attachmentpage.id,
                            path : attachmentpage.path
                        }

                        this.pages.splice(index_start,0,page);
                    });
                }
            });
        },
        setPageSize(){
            let width, height;

            if(this.$refs.spread){
                let new_width, new_height, new_rect;
                let spread = this.$refs.spread;
                let rect = spread.getBoundingClientRect();
                
                this.width = rect.width - (this.spreadMargin * 2);
                this.height = rect.height - (this.spreadMargin * 2);

                this.paper_width = this.printable.printable_type.paper_width;
                this.paper_height = this.printable.printable_type.paper_height;               

                this.ratio = this.paper_height / this.paper_width;

                if(this.width >= this.height){
                    new_rect = this.sizeByHeight(this.width,this.height);
                } else {
                    new_rect = this.sizeByWidth(this.width,this.height);
                }
                
                this.page_height = new_rect.height;
                this.page_width = new_rect.width;
            }
        },
        sizeByHeight(width,height){
            this.scale_factor = height / this.paper_height;
            let new_width = this.paper_width * this.scale_factor;

            if((new_width + (this.spreadMargin )) * 2 > this.width){
                return this.sizeByHeight(width * 0.99, height * 0.99)
            }

            return {
                width : new_width,
                height : height
            }
        },
        sizeByWidth(width,height){
            this.scale_factor =  width / this.paper_width;
            let new_height = this.paper_height * this.scale_factor;

            if((new_height + (this.spreadMargin * 2)) * 2 > this.height){
                return this.sizeByWidth(width * 0.99, height * 0.99)
            }

            return {
                width : width,
                height : new_height
            }
        },
        getPage(item,counter){
            return {
                attachment_id : item.attachment_id,
                attachment_page_id : item.attachment_page_id,
                template_id : item.template_id,
                template_area_id : item.id,
                disable_pagination : item.disable_pagination, 
                printable_page_number : counter
            }
        },
        async savePages(){
            let pages = [];
            let counter = 1;

            this.pages.forEach(page => {

                if(page.templateareas){
                    page.templateareas.forEach(area => {
                        pages.push(this.getPage(area,counter));
                    });

                } else {
                    pages.push(this.getPage(page,counter));
                }
                
                counter++;
            });
            
            const { data } = await axios.post('/api/printable/' + this.printable_id + '/pages',{'pages': pages});
            //this.printable = data;
            this.$emit('update-printable');
        },
        async fetchData(){
            const { data } = await axios.get('/api/printable/' + this.printable_id)

            this.printable = data;
            this.loading = false;
            
            this.parsePrintable()
        }
    },
    
    props: [
        'printable',
        'open'
    ],
    watch: {
        printable (newId,oldId) {
            if (this.printable && !this.visible){
                this.show('route')
            } else if (!this.printable && this.visible) this.hide()

            if(this.printable){
                this.parsePrintable()
            }
        },
    },
}
</script>
<style lang="scss" scoped>

@import '~bootstrap/scss/bootstrap';
.wrapper {
    height: 100%;
}
.assemble {
    max-height: 87vh !important;
    @extend .d-flex;
    @extend .h-100;

    .spread {
        @extend .d-flex;
        @extend .flex-grow-1;
        @extend .justify-content-center;
    }

    .tool {
        /*padding: .3rem;
        padding-left: .3rem;
        padding-right: .3rem;
        text-align: center;
        border-radius: 1rem;
        border: none;
        line-height: 1;*/
        padding: 0.075rem 0.35rem 0.175rem 0.35rem;

        &:hover {
            text-decoration: none;
        }

        &-warning {
            @extend .bg-warning;
        }

        &-success {
            @extend .bg-success;
        }

        &-danger {
            @extend .bg-danger;
        }

        &-info {
            @extend .bg-info;
        }
    }

    .templates {
        width: 70px;

        &-page {
            background: #fff;
            float:left;
            margin-right: 4px;
            margin-top: 4px;
            border: 1px solid #ccc;
            position: relative;    
            cursor: pointer;

            &::before {
                @extend .d-flex;
                @extend .justify-content-center;
                @extend .align-items-center;
                
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                font-size: .8rem;
                font-weight: bold;
                content: attr(data-page);
                background: rgba(255,255,255,0.6);
            }

            &.add-new::before {
                font-weight: normal;
                opacity: .5;
            }
        }
    }

    .disposition {
        width: 95px;
        overflow-y: auto;
        overflow-x: hidden;

        &.displace {
            .disposition-page:first-child {
                margin-left: 37px;
            }
            .disposition-page:nth-child(2n) {
                margin-right: 4px!important;
            }
            .disposition-page:nth-child(1n) {
                margin-right: 0;
            }
        }

        &-tools {
            display: none;
        }

        &-page {
            background: #fff;
            float:left;
            margin-right: 4px;
            margin-top: 4px;
            border: 1px solid #ccc;
            position: relative;    
            cursor: pointer;

            &:nth-child(2n) {
                margin-right: 0;
            }

            &.add-new {
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                    position: relative;
                    z-index: 9999;
                }
            }

            &.spread {
                width: 100%;

                /*&::after {
                    content: '';
                    border-left: 1px solid #ccc;
                    position: absolute;
                    left: 50%;
                    height: 100%;
                }*/
            }

            &::before {
                @extend .d-flex;
                @extend .justify-content-center;
                @extend .align-items-center;
                
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                font-size: .8rem;
                font-weight: bold;
                content: attr(data-page);
                background: rgba(255,255,255,0.6);
            }

            &.add-new::before {
                font-weight: normal;
                opacity: .5;
            }
        }
    }

    .disposition-page:hover .disposition-tools {
        @extend .bg-warning;

        display: block;
        position: absolute;
        top: -1px;
        right: -1.5rem;
        z-index: 9999;
        font-size: 0.7rem;
        padding: 0.1rem .3rem 0.3rem .3rem;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        a {
            color: #fff;
        }
    }

    .components {
        width: 300px;
    }

    .side-left,
    .side-right {
        background: #fff;
        margin-right: .2%;
        border: 1px solid #ccc;
        box-shadow: 0 2px 6px 0 hsla(0,0,0,.05);
        position: relative;
        background-size: cover;

        .page-tools {
            opacity: 1;
            position: absolute;
            bottom: 1rem;
            right: 1rem;
            left: 1rem;
            transition: opacity .3s ease;
        }

        &:hover .page-tools {
            opacity: 1;
        }

        &.hidden {
            visibility: hidden;
        }

        &::before {
            content: ' ';
            background: pink;
        }
    }
    .active {
        border: 1px solid $danger;
    }

    .template-area {
        background: rgba(200,200,200,.3);
        background-size: contain;
        background-repeat: no-repeat;
        border: 1px solid #ccc;
        position: absolute;
        overflow: hidden;

        &.active {
            border: 1px solid $danger;
            background-color: pink;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/AssembleModal.vue